








































import { FormModel } from 'ant-design-vue';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class SetWarn extends Vue {
  public visible: boolean = false;
  protected columns: TypeBase.TableColumn[] = [];
  protected piWarningQty: number = 0;
  protected formData: TypeInventoryAge.SetAgeWarnParam = {
    list: [],
  };
  protected formDataRule = {
    'list.*.iba_warning_age': [
      { required: true, message: this.t('请输入预警库龄') },
      { type: 'integer', message: this.t('请输入整数') },
    ],
  };
  @Prop({ type: Array, default: () => [] })
  protected data!: TypeInventoryAge.ListItem[];
  @Watch('visible')
  protected onVisibleChange(value: boolean): void {
    if (value === false) {
      this.initData();
      this.piWarningQty = 0;
      const formDataRef = this.$refs.formDataRef as FormModel;
      formDataRef.resetFields();
    }
  }
  @Watch('data')
  protected onDataChange(data: TypeInventoryAge.List): void {
    this.formData = {
      list: this.getRowsFromData(data),
    };
  }
  protected getRowsFromData(data: TypeInventoryAge.List): TypeInventoryAge.SetAgeWarnItem[] {
    const arr: TypeInventoryAge.SetAgeWarnItem[] = [];
    data.forEach((item: TypeInventoryAge.ListItem) => {
      arr.push({
        iba_fifo_time: item.iba_fifo_time,
        iba_warning_age: item.iba_warning_age || 0,
        warehouse_code: item.warehouse_code,
        product_barcode: item.product_barcode,
        product_sku: item.product_sku,
        _warehouse_desc: item.warehouse_desc,
      });
    });
    return arr;
  }
  protected async setWarningQtyBulk(params: TypeInventoryAge.SetAgeWarnParam): Promise<void> {
    const res = await this.$api.warehouse.updateWarnAge(params);
    if (res.code === 0) {
      this.$message.success(this.t('设置成功'));
      this.$emit('success');
      this.visible = false;
    }
  }
  protected handleSubmit(): void {
    const formDataRef = this.$refs.formDataRef as FormModel;
    formDataRef.validate((valid: boolean) => {
      if (valid) {
        this.setWarningQtyBulk(this.formData);
      }
    });
  }
  /**
   * 库龄格式化为整数
   */
  protected formatter(num: number | string): string {
    const res = String(num).match(/([0-9]{0,4})/);
    if (res && res[1]) {
      return res[1];
    } else {
      return '';
    }
  }
  protected initData(): void {
    this.formData = { list: this.getRowsFromData(this.data) };
  }
  protected created(): void {
    const h = this.$createElement;
    this.columns = [
      {
        title: this.t('商品编码'),
        dataIndex: 'product_sku',
      },
      {
        title: this.t('仓库（区域）'),
        scopedSlots: {
          customRender: 'warehouse_code',
        },
      },
      {
        title: () => {
          return (
            <div style='display: flex;align-items: center;'>
              <span class='mr-10'>{this.t('预警库龄')}</span>
              <a-input-number
                value={this.piWarningQty}
                min={0}
                style='width: 100%'
                formatter={this.formatter}
                onChange={(value: number) => {
                  this.formData.list.forEach((item: TypeInventoryAge.SetAgeWarnItem) => {
                    item.iba_warning_age = value;
                  });
                  this.piWarningQty = Number(value);
                }}
                onBlur={(e: Event) => {
                  const el = e.target as HTMLInputElement;
                  const value = Number(el.value);
                  this.formData.list.forEach((item: TypeInventoryAge.SetAgeWarnItem) => {
                    item.iba_warning_age = value;
                  });
                  const formDataRef = this.$refs.formDataRef as FormModel;
                  if (formDataRef) {
                    formDataRef.validate();
                  }
                  this.piWarningQty = Number(value);
                }}
                placeholder={this.t('批量修改')}
              />
            </div>
          );
        },
        scopedSlots: {
          customRender: 'warn',
        },
      },
    ];
  }
}
